import {useRef, useSyncExternalStore} from 'react';
import {createArticleDraft} from './articleDraft.js';

export function useArticleDraft(userId, onStorageError) {
  const context = useRef();
  context.current = {userId, onStorageError};
  const draft = useRef();
  if (!draft.current) draft.current = createArticleDraft({storage: localStorage,
    userId: () => context.current.userId,
    onStorageError: message => context.current.onStorageError(message)});
  const edit = useSyncExternalStore(draft.current.subscribe, draft.current.getSnapshot);
  return {edit, draft: draft.current, setEdit: draft.current.replace};
}
